import { render, staticRenderFns } from "./TaskItems.vue?vue&type=template&id=5efd793b"
import script from "./TaskItems.vue?vue&type=script&lang=js"
export * from "./TaskItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports